/**
 * Puntea intre `client.ts` (axios, in afara arborelui React) si `AuthProviderV2`.
 *
 * De ce exista (2.15, 2026-08-28): cand refresh-ul de token esua, `client.ts` stergea cele trei
 * chei din localStorage si se baza — conform comentariului — pe un listener de `storage` din
 * provider care sa faca logout. Listenerul NU exista ("Cross-tab storage sync removed"), iar
 * evenimentul `storage` oricum nu se declanseaza in tab-ul care scrie. Efect: state-ul React
 * ramanea cu tokenul vechi, AuthenticatedLayout vedea `token` truthy si nu redirecta, iar userul
 * ramanea vizual logat pe o pagina in care fiecare cerere esua tacut.
 *
 * Nu e un decident de redirect: singurul listener e `logout()` din provider, care navigheaza
 * deja la login. Aici doar se transmite semnalul.
 */
export type SessionExpiredListener = () => void;

const listeners = new Set<SessionExpiredListener>();

export function onSessionExpired(listener: SessionExpiredListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitSessionExpired(): void {
  for (const listener of Array.from(listeners)) {
    try {
      listener();
    } catch (error) {
      console.error('[session-expired] listener failed:', error);
    }
  }
}
